import { render, staticRenderFns } from "./CartPageAdditionalAcquisition.vue?vue&type=template&id=5edbaf10&scoped=true"
import script from "./CartPageAdditionalAcquisition.vue?vue&type=script&lang=js"
export * from "./CartPageAdditionalAcquisition.vue?vue&type=script&lang=js"
import style0 from "./CartPageAdditionalAcquisition.vue?vue&type=style&index=0&id=5edbaf10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edbaf10",
  null
  
)

export default component.exports